export const LOGIN_API = '/api/v1/auth/users/sign_in'
export const LOGIN_SSO_API = '/api/v1/auth/users/sso'
export const LOGOUT_API = '/api/v1/auth/users/sign_out'
export const INVITATIONS_CONFIRM_API = '/api/v1/auth/invitations/confirm'
export const DOWNLOAD_FILE_API = '/api/v1/attachments/download'
export const SIGN_OUT_API = '/api/auth/sign-out'
export const CHUB_SIGN_OUT_URL = (slug: string) => `/api/careerhub/auth/${slug}/sign-out`
export const VERIFY_RECAPTCHA_API = '/api/verify-recaptcha'
export const VERIFY_LOGIN_MICROSOFT_API = '/api/verify-login-microsoft'
export const GRAPHQL_API = '/graphql'
export const CHUB_API = '/careerhub'
export const PROFILES_EXPORT_CSV_API = '/api/v1/profiles/export'
export const JOBS_EXPORT_CSV_API = '/api/v1/jobs/export'
export const DEPARTMENT_EXPORT_CSV_API = '/api/v1/departments/export'
export const MEMBERS_EXPORT_CSV_API = '/api/v1/users/export_members'
export const PROFILE_NOTES_EXPORT_API = '/api/v1/profiles/export_profile_notes'

export const REPORT_EXPORT_TEAM_PRODUCTIVITY = '/api/v1/reports/export_team_productivity'
export const REPORT_EXPORT_TIME_TO_HIRE = '/api/v1/reports/export_time_to_hire'
export const REPORT_EXPORT_REFERRAL = '/api/v1/reports/export_referral'
export const REPORT_EXPORT_CANDIDATE_SOURCE = '/api/v1/reports/export_candidate_source'
export const CALENDAR_FEED_ICS_API = '/api/v1/events/show_calendar'
export const SKILL_SETTING_EXPORT = '/api/v1/skills/export'
export const CHUB_AI_ADVISOR_API = '/tf-rag/api/v1/chatbots'
export const TF_RAG_API = '/tf-rag'
export const CUSTOM_REPORT_API = '/custom-report'
export const START_AI_INTERVIEW = (eventId: string) =>
  `/api/v1/public/ai_interviews/start?event_id=${eventId}`
export const COMPLETE_AI_INTERVIEW = (eventId: string) =>
  `/api/v1/public/ai_interviews/complete?event_id=${eventId}`

// Chub
export const CHUB_POSITION_ANALYSIS_API = '/careerhub/api/v1/positions/analysis'
export const CHUB_SIGN_OUT_API = '/careerhub/api/v1/auth/users/sign_out'
export const INVITATIONS_CHUB_CONFIRM_API = '/careerhub/api/v1/auth/invitations/confirm'
export const LOGIN_CHUB_API = '/careerhub/api/v1/auth/users/sign_in'
export const DOWNLOAD_CHUB_FILE_API = '/careerhub/api/v1/attachments/download'
export const CHUB_MEMBER_EXPORT_CSV_API = '/api/v1/users/export_chub_members'
export const AUDIT_LOG_EXPORT_CSV_API = '/api/v1/audit_logs/export'
